export enum Status {
    none = "none",
    executed = "executed",
    overdue = "overdue",
    inProgress = "inProgress",
    available = "available",
    upcoming = "upcoming",
    incomplete = "incomplete"
}